/* eslint-disable no-console */
import React, { useCallback, useEffect, useRef } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text, Button } from "@izettle/react"

import CustomerImageAsset from "@/assets/poa.png"
import CustomerImageAsset2x from "@/assets/poa@2x.png"
import CustomerImageAsset3x from "@/assets/poa@3x.png"
import { PageWrapper } from "@/components/layout-helpers"
import { redirectToBackOffice } from "@/helpers"
import { closeWebview } from "@/util"

const StyledPageWrapper = styled(PageWrapper)`
  align-items: center;
`

const CustomerImage = styled.img`
  width: 100%;
  max-width: 227px;
  height: auto;
  margin-bottom: ${spacing.medium};
`

const TextWrapper = styled.div`
  text-align: center;
`

const PageTitle = styled(Text.Title2)`
  margin-top: ${spacing.none};
`

const PageText = styled(Text.RegularSecondary)`
  margin-bottom: ${spacing.large};
`

export const Done: React.FC = () => {
  const { text } = useLocalization()
  const closeBtn = useRef<HTMLButtonElement>(null)

  const onCloseClick = useCallback(() => {
    closeWebview()
    redirectToBackOffice()
  }, [])

  useEffect(() => {
    closeBtn?.current?.focus()
  }, [closeBtn?.current])

  return (
    <StyledPageWrapper>
      <CustomerImage
        srcSet={`${CustomerImageAsset},
        ${CustomerImageAsset2x} 2x,
        ${CustomerImageAsset3x} 3x`}
        alt=""
        aria-hidden
      />
      <TextWrapper aria-live="assertive">
        <PageTitle>{text("DONE_HEADING")}</PageTitle>
        <PageText>{text("DONE_TEXT")}</PageText>
      </TextWrapper>
      <Button ref={closeBtn} variant="secondary" onClick={onCloseClick}>
        {text("DONE_DASHBOARD_BUTTON")}
      </Button>
    </StyledPageWrapper>
  )
}
